export interface Employee {
  id: string
  name: string
  role: string
  phone?: string
  image?: string
}

// Add employees here. Image paths point to files in public/,
// e.g. put photos in public/employees/ and reference them as '/employees/name.jpg'.
export const employees: Employee[] = []
